import { request } from '@/utils/infrastructure/communication';
import { toQuery } from '@/utils/infrastructure';

const BASE_URL = '/notification';
const DEFAULT_ORDER_BY = 'created desc';

const buildPagedParams = ({ page, limit, orderBy, filter }) => {
  return toQuery({
    page,
    limit,
    orderBy: orderBy || DEFAULT_ORDER_BY,
    ...(filter && { filter }),
  });
};

export const fetchNotificationsPaged = ({
  page = 1,
  limit = 20,
  orderBy = DEFAULT_ORDER_BY,
  filter,
} = {}) => {
  return request(`${BASE_URL}/paged`, {
    params: buildPagedParams({ page, limit, orderBy, filter }),
    readPriority: true,
  });
};

export const markNotificationAsRead = (notificationId) => {
  if (!notificationId) return Promise.resolve();
  return request.post(`${BASE_URL}/markAsRead/${notificationId}`, {});
};

export const markAllNotificationsAsRead = () => {
  return request.post(`${BASE_URL}/markAllAsRead`, {});
};

export const deleteNotification = (notificationId) => {
  if (!notificationId) return Promise.resolve();
  return request.delete(`${BASE_URL}/${notificationId}`, {});
};

export const deleteAllNotifications = () => {
  return request.delete(`${BASE_URL}/deleteAll`, {});
};

export const fetchNotificationCount = () => {
  return request(`${BASE_URL}/count`);
};
